// Constants used only by the Transcript feature.

// Zoom in-meeting chat message posted when transcription starts.
export const AIMS_START_DISCLAIMER_CHAT_MESSAGE = `Review Amazon's Recording, Transcription, and Summarization Policy for permitted meeting types.
https://policy.a2z.com/docs/693659/publication

Notify attendees when meetings are being summarized or transcribed.

Meeting organizers are responsible for compliance. Refer to wiki for guidelines.
https://w.amazon.com/bin/view/UnifiedCommunications/MeetingSummaries/AiMS`;

// Zoom in-meeting chat message posted when a LEO interviewer starts transcription in a HIRE interview.
export const LEO_INTERVIEW_CHAT_MESSAGE =
  "This interview is being transcribed. As a reminder, please do not discuss any export-controlled technical details during this session.";
